<template>
    <div style="margin-left: 5px;width: 55px;margin-top: 20px;">
        <div class="drawer">
            <input id="batch-settings" type="checkbox" class="drawer-toggle" v-model="settingCheckBox"/>
            <div class="drawer-content">
                <!-- Page content here -->
                <label for="batch-settings" class="btn btn-sm drawer-button" v-bk-tooltips="'配置'">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else>
                        <svg t="1704707420078" class="icon fill-current w-6 h-6" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="2430" width="200" height="200"><path
                            d="M511.099222 365.825763c-80.7786 0-146.26579 65.482515-146.26579 146.259556 0 80.7786 65.48719 146.259556 146.26579 146.259556 80.777041 0 146.259556-65.480957 146.259556-146.259556C657.358779 431.308278 591.876263 365.825763 511.099222 365.825763L511.099222 365.825763zM511.099222 585.215097c-40.391637 0-73.136012-32.742816-73.136012-73.129778 0-40.391637 32.742816-73.129778 73.136012-73.129778 40.386962 0 73.129778 32.738141 73.129778 73.129778C584.229 552.472281 551.486184 585.215097 511.099222 585.215097L511.099222 585.215097zM511.099222 585.215097M900.893017 568.24369l-26.451395-15.268032c3.065451-27.021784 3.138697-54.472139 0.077922-81.822754l26.373473-15.225955c69.953678-40.391637 93.920921-129.844512 53.533959-199.799749-40.390079-69.95212-129.839837-93.925596-199.799749-53.533959l-26.373473 15.225955c-22.153219-16.330888-45.963059-29.99217-70.896534-40.843585l0-30.545416c0-80.777041-65.48719-146.259556-146.26579-146.259556-80.7786 0-146.259556 65.482515-146.259556 146.259556l0 30.515806c-12.377127 5.421811-24.587501 11.55583-36.562551 18.473743-11.97505 6.917913-23.396854 14.420242-34.277879 22.432179l-26.431136-15.258682c-69.958353-40.391637-159.406553-16.424395-199.79819 53.533959C27.378272 326.082437 51.343956 415.535311 121.299193 455.922273l26.449837 15.275825c-3.063892 27.020226-3.137139 54.465905-0.077922 81.822754l-26.373473 15.224397c-69.953678 40.391637-93.920921 129.841395-53.533959 199.799749 40.391637 69.95212 129.839837 93.920921 199.79819 53.533959l26.375032-15.224397c22.153219 16.32933 45.963059 29.984378 70.896534 40.843585l0 30.537624c0 80.7786 65.48719 146.26579 146.26579 146.26579 80.777041 0 146.259556-65.48719 146.259556-146.26579l0-30.515806c12.377127-5.415577 24.587501-11.55583 36.567226-18.467509 11.97505-6.917913 23.398412-14.420242 34.277879-22.432179l26.423343 15.258682c69.959912 40.391637 159.408111 16.418162 199.799749-53.533959C994.813938 698.085085 970.848254 608.635327 900.893017 568.24369L900.893017 568.24369zM891.096666 731.474653c-20.198936 34.982294-64.923035 46.962019-99.900654 26.770875l-63.331869-36.567226 0 0 0 0-7.988562-4.611422c-18.134004 18.450366-39.024886 34.787489-62.516805 48.353705-23.49971 13.559983-48.091888 23.482568-73.129778 29.964118l0 9.222846 0 0 0 65.828489 0 7.301289c0 40.391637-32.742816 73.136012-73.136012 73.136012-40.386962 0-73.129778-32.742816-73.129778-73.136012l0-7.402588 0-65.72719 0 0 0-9.300768c-50.682014-13.090892-97.855981-39.682547-135.652816-78.232109l-7.983886 4.606747 0 0-63.331869 36.567226c-34.977618 20.191144-79.706394 8.206743-99.900654-26.770875-20.192702-34.977618-8.206743-79.701718 26.770875-99.899095l6.341291-3.657657 0 0 64.972905-37.516316c-14.487254-52.005129-13.929333-106.151555 0.073247-156.593569l-8.057133-4.650384 0 0-63.331869-36.567226c-34.982294-20.192702-46.963578-64.923035-26.770875-99.900654 20.192702-34.97606 64.923035-46.962019 99.900654-26.763083l6.324148 3.649866 0 0 64.996282 37.528784c18.132445-18.450366 39.024886-34.790606 62.516805-48.353705 23.493477-13.559983 48.085654-23.485685 73.129778-29.964118l0-9.229079L437.960093 153.739276l0-7.309082c0-40.385404 32.742816-73.129778 73.129778-73.129778 40.391637 0 73.129778 32.744375 73.129778 73.129778l0 7.404147 0 65.72719 0 9.307001c50.686689 13.086217 97.862215 39.684106 135.657491 78.232109l48.487732-27.997368 22.828023-13.176607c34.977618-20.192702 79.701718-8.212977 99.89442 26.763083 20.198936 34.982294 8.212977 79.706394-26.764641 99.900654l-30.822819 17.79738-32.50905 18.769847 0 0 0 0-7.983886 4.605189c14.488813 52.009805 13.929333 106.159347-0.077922 156.599803l64.979139 37.511641 0 0 6.414537 3.701294C899.303409 651.772936 911.289368 696.498594 891.096666 731.474653L891.096666 731.474653zM891.096666 731.474653M197.330785 324.240361c-1.932465 3.232203-3.824411 6.497135-5.649343 9.785442L197.330785 324.240361 197.330785 324.240361zM197.330785 324.240361M830.515443 690.133926l-5.655577 9.804144C826.793889 696.699632 828.685835 693.433143 830.515443 690.133926L830.515443 690.133926zM830.515443 690.133926M505.297151 146.430195l11.304921 0C512.835324 146.369416 509.067017 146.374091 505.297151 146.430195L505.297151 146.430195zM505.297151 146.430195M516.898176 877.740444l-11.31583 0C509.350653 877.796547 513.125193 877.796547 516.898176 877.740444L516.898176 877.740444zM516.898176 877.740444"></path></svg>
                    </span>
                </label>
            </div>
            <div class="drawer-side">
                <label for="batch-settings" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">详情显示设置</div>
                        <button class="btn btn-sm btn-primary" @click="handleBatchSettings">保存</button>
                    </div>
                    <div>
                        <div class="form-control">
                            <label class="label cursor-pointer">
                                <span class="label-text">开启详情页</span>
                                <input type="checkbox" class="toggle toggle-primary"
                                       v-model="batchSettingFormData.isOpenDetail"/>
                            </label>
                        </div>
                        <div class="form-control">
                            <label class="label cursor-pointer">
                                <span class="label-text">开启深度遍历</span>
                                <input type="checkbox" class="toggle toggle-primary"
                                       v-model="batchSettingFormData.isDepth"/>
                            </label>
                            <div class="text-gray-400 text-sm">会显示子文件夹下的文件信息</div>
                        </div>
                        <div class="form-control">
                            <label class="label cursor-pointer">
                                <span class="label-text">限制条数</span>
                                <input type="number" placeholder="请输入" class="input input-bordered input-sm max-w-xs"
                                       v-model="batchSettingFormData.limit"/>
                            </label>
                            <div class="text-gray-400 text-sm">显示详情列表的条数,避免卡住页面</div>
                        </div>
                        <div class="form-control">
                            <label class="label cursor-pointer">
                                <span class="label-text">显示字段</span>
                            </label>
                            <multi-select :options="fieldListID3" v-model="showFieldsID3"></multi-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div style="margin-top: 10px;">
            <div class="drawer">
                <input id="hand-edit" type="checkbox" class="drawer-toggle" v-model="handModifyCheckBox"/>
                <div class="drawer-content">
                    <!-- Page content here -->
                    <label for="hand-edit" class="btn btn-sm drawer-button" v-bk-tooltips="'手动刮削'">
                        <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                        <span v-else>
                            <svg t="1704705230255" class="icon fill-current w-6 h-6" viewBox="0 0 1024 1024"
                                 version="1.1" xmlns="http://www.w3.org/2000/svg"><path
                                d="M358.165868 554.624796c-0.533143 0.680499-1.066285 1.391696-1.303692 2.251274l-41.104163 150.700257c-2.400676 8.772804 0.059352 18.226107 6.550183 24.892947 4.860704 4.742001 11.261485 7.350408 18.077727 7.350408 2.252297 0 4.504594-0.267083 6.727215-0.860601l149.630902-40.808428c0.23843 0 0.357134 0.207731 0.534166 0.207731 1.718131 0 3.408633-0.62217 4.683672-1.927909l400.113747-400.054395c11.883655-11.897981 18.404162-28.109198 18.404162-45.74281 0-19.989263-8.476045-39.963177-23.324218-54.767348l-37.786605-37.844933c-14.81645-14.848173-34.822087-23.338544-54.797024-23.338544-17.631566 0-33.842783 6.520507-45.75816 18.388812L358.758362 553.232077C358.344946 553.615816 358.462626 554.179658 358.165868 554.624796M862.924953 257.19778l-39.742143 39.71349-64.428382-65.451688 39.180348-39.179324c6.193049-6.222725 18.194384-5.318122 25.308409 1.822508l37.813211 37.845956c3.943822 3.941775 6.195096 9.18622 6.195096 14.372336C867.223862 250.574942 865.710392 254.42769 862.924953 257.19778M429.322487 560.907896l288.712541-288.728914 64.459081 65.49569L494.314711 625.838721 429.322487 560.907896zM376.718409 677.970032l20.863167-76.580143 55.656601 55.657624L376.718409 677.970032z"
                                p-id="3458"></path><path
                                d="M888.265084 415.735539c-15.144932 0-27.562752 12.313443-27.620058 27.665083l0 372.98283c0 19.559475-15.885805 35.444257-35.475979 35.444257L194.220958 851.827709c-19.559475 0-35.504632-15.883759-35.504632-35.444257L158.716326 207.602222c0-19.575848 15.945157-35.474956 35.504632-35.474956l406.367171 0c15.231913 0 27.592428-12.371772 27.592428-27.606755 0-15.202237-12.360516-27.590382-27.592428-27.590382L190.013123 116.930129c-47.684022 0-86.49291 38.779212-86.49291 86.49291L103.520213 820.59231c0 47.713698 38.808888 86.47756 86.49291 86.47756l639.334083 0c47.715745 0 86.509283-38.763862 86.509283-86.47756L915.856489 443.222567C915.794068 428.048983 903.408993 415.735539 888.265084 415.735539"
                                p-id="3459"></path></svg>
                        </span>
                    </label>
                </div>
                <div class="drawer-side">
                    <label for="hand-edit" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                        <div class="flex justify-between items-center mb-4">
                            <div class="text-xl font-medium">手动修改标签</div>
                            <button class="btn btn-sm btn-primary" @click="handleBatch">保存</button>
                        </div>
                        <div style="display: flex;margin-bottom: 10px;align-items: center;margin-top: 10px;">
                            <div class="label1 can-copy" v-bk-tooltips="'变量名:${title}'" v-bk-copy="'${title}'">标题：</div>
                            <div style="width: 70%;">
                                <input type="text"
                                       v-model="musicInfoManual.title"
                                       placeholder="支持变量批量修改"
                                       class="input input-bordered input-sm w-full max-w-xs"/>
                            </div>
                        </div>
                        <div v-for="(item, index) in showFields" :key="'l2' + index">
                            <div class="edit-item" v-if="item === 'filename'">
                                <div class="label1 can-copy" v-bk-tooltips="'变量名:${filename}'"
                                     v-bk-copy="'${filename}'">
                                    文件名：
                                </div>
                                <div style="width: 70%;">
                                    <input type="text"
                                           v-model="musicInfoManual.filename"
                                           placeholder="例如：${title}-${album}"
                                           class="input input-bordered input-sm w-full max-w-xs"/>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'artist'">
                                <div class="label1 can-copy" v-bk-tooltips="'变量名:${artist}'" v-bk-copy="'${artist}'">
                                    艺术家：
                                </div>
                                <div style="width: 70%;">
                                    <input type="text"
                                           v-model="musicInfoManual.artist"
                                           placeholder="具体哪些变量,鼠标悬浮在标题上查看"
                                           class="input input-bordered input-sm w-full max-w-xs"/>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'album'">
                                <div class="label1 can-copy" v-bk-tooltips="'变量名:${album}'" v-bk-copy="'${album}'">专辑：
                                </div>
                                <div style="width: 70%;">
                                    <input type="text"
                                           v-model="musicInfoManual.album"
                                           placeholder="${null}为清空标签"
                                           class="input input-bordered input-sm w-full max-w-xs"/>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'albumartist'">
                                <div class="label1 can-copy" v-bk-tooltips="'变量名:${albumartist}'"
                                     v-bk-copy="'${albumartist}'">专辑艺术家：
                                </div>
                                <div style="width: 70%;">
                                    <div class="w-full max-w-xs">
                                        <bk-tag-input
                                            v-model="albumArtistInputList"
                                            :list="albumArtistList"
                                            :allow-create="true"
                                            :trigger="'focus'"
                                            :max-data="1"
                                            :allow-auto-match="true"
                                            :has-delete-icon="false">
                                        </bk-tag-input>
                                    </div>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'genre'">
                                <div class="label1">风格：</div>
                                <div style="width: 70%;">
                                    <div class="w-full max-w-xs">
                                        <bk-tag-input
                                            v-model="genreInputList"
                                            :list="genreList"
                                            :allow-create="true"
                                            :trigger="'focus'"
                                            :max-data="1"
                                            :allow-auto-match="true"
                                            :has-delete-icon="false">
                                        </bk-tag-input>
                                    </div>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'language'">
                                <div class="label1">语言：</div>
                                <div style="width: 70%;">
                                    <div class="w-full max-w-xs">
                                        <bk-tag-input
                                            v-model="languageInputList"
                                            :list="languageList"
                                            :allow-create="true"
                                            :trigger="'focus'"
                                            :max-data="1"
                                            :allow-auto-match="true"
                                            :has-delete-icon="false">
                                        </bk-tag-input>
                                    </div>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'year'">
                                <div class="label1">年份：</div>
                                <div style="width: 70%;">
                                    <input type="text"
                                           v-model="musicInfoManual.year"
                                           class="input input-bordered input-sm w-full max-w-xs"/>
                                </div>
                            </div>
                            <div style="display: flex;margin-bottom: 10px;flex-direction: column;"
                                 v-else-if="item === 'lyrics'">
                                <div style="display: flex;">
                                    <div class="label1">歌词：</div>
                                    <div style="display: flex;flex-direction: column;width: 70%;">
                                        <div>
                                            <div class="form-control w-full max-w-xs">
                                                <textarea placeholder="请填入歌词" v-model="musicInfoManual.lyrics"
                                                          class="textarea textarea-bordered textarea-xs w-full max-w-xs h-48">
                                                </textarea>
                                                <label class="label">
                                                    <span class="label-text-alt">
                                                        <div style="display: flex;margin-top: 10px;margin-right: 20px;">
                                                            <div class="text-xs mr-2 tooltip"
                                                                 data-tip="将元数据中的歌词导出为 ${filename}.lrc ">导出 lrc:</div>
                                                            <input type="checkbox"
                                                                   class="toggle toggle-xs toggle-primary"
                                                                   v-model="isSaveLyricsFile"/>
                                                        </div>
                                                    </span>
                                                    <span class="label-text-alt">
                                                        <div style="display: flex;margin-top: 10px;">
                                                            <div class="text-xs mr-2 tooltip"
                                                                 data-tip="将${filename}.lrc文件导入元数据中的歌词处">导入 lrc:</div>
                                                            <input type="checkbox"
                                                                   class="toggle toggle-xs toggle-primary"
                                                                   v-model="isImportLyricsFile"/>
                                                        </div>
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'comment'">
                                <div class="label1">描述：</div>
                                <div style="width: 70%;">
                                    <textarea placeholder="请填入描述" v-model="musicInfoManual.comment"
                                              class="textarea textarea-bordered textarea-xs w-full max-w-xs">
                                    </textarea>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'description'">
                                <div class="label1">描述2：</div>
                                <div style="width: 70%;">
                                    <textarea placeholder="请填入描述" v-model="musicInfoManual.description"
                                              class="textarea textarea-bordered textarea-xs w-full max-w-xs">
                                    </textarea>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'album_img'">
                                <div class="label1">专辑封面：</div>
                                <div style="display: flex;flex-direction: column;">
                                    <div style="width: 70%;display: flex;flex-direction: column;" v-if="reloadImg">
                                        <div>
                                            <bk-upload
                                                :files="files1"
                                                :theme="'picture'"
                                                :multiple="false"
                                                :with-credentials="true"
                                                :header="uploadHeader"
                                                :handle-res-code="handleResBatch"
                                                :size="{ maxFileSize: 5, maxImgSize: 20 }"
                                                :url="uploadUrl"
                                                @on-delete="handleHide"
                                                name="upload_file"
                                            ></bk-upload>
                                        </div>
                                    </div>
                                    <div style="display: flex;margin-top: 10px;">
                                        <div class="text-xs mr-1">导出图片：</div>
                                        <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                               v-model="isSaveAlbumCover"/>
                                        <div class="text-xs mr-1 ml-8">导入图片：</div>
                                        <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                               v-model="isImportAlbumCover"/>
                                    </div>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'discnumber'">
                                <div class="label1 can-copy" v-bk-tooltips="'变量名:${discnumber}'"
                                     v-bk-copy="'${discnumber}'">光盘编号：
                                </div>
                                <div style="width: 70%;">
                                    <input type="text"
                                           v-model="musicInfoManual.discnumber"
                                           class="input input-bordered input-sm w-full max-w-xs"/>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'tracknumber'">
                                <div class="label1 can-copy" v-bk-tooltips="'变量名:${tracknumber}'"
                                     v-bk-copy="'${tracknumber}'">音轨号：
                                </div>
                                <div style="width: 70%;">
                                    <input type="text"
                                           v-model="musicInfoManual.tracknumber"
                                           class="input input-bordered input-sm w-full max-w-xs"/>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'totaltracks'">
                                <div class="label1 can-copy">总音轨数：</div>
                                <div style="width: 70%;">
                                    <input type="text"
                                           v-model="musicInfoManual.totaltracks"
                                           class="input input-bordered input-sm w-full max-w-xs"/>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'totaldiscs'">
                                <div class="label1">总光盘数：</div>
                                <div style="width: 70%;">
                                    <input type="text"
                                           v-model="musicInfoManual.totaldiscs"
                                           class="input input-bordered input-sm w-full max-w-xs"/>
                                </div>
                            </div>
                            <div class="edit-item" v-else-if="item === 'album_type'">

                                <div class="label1">专辑类型：</div>
                                <div style="width: 70%;">
                                    <select class="select select-bordered select-sm w-full max-w-xs"
                                            v-model="musicInfoManual.album_type">
                                        <option v-for="option in albumTypeList"
                                                :key="option.id"
                                                :id="option.id"
                                                :value="option.id"
                                                class="bg-base-100"
                                        >
                                            {{ option.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 100%;display: flex;margin-top: 10px;">
            <div class="drawer">
                <input id="auto-edit" type="checkbox" class="drawer-toggle" name='auto-edit'
                       v-model="autoModifyCheckBox"/>
                <div class="drawer-content">
                    <!-- Page content here -->
                    <label for="auto-edit" class="btn btn-sm drawer-button" v-bk-tooltips="'自动刮削'">
                        <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                        <span v-else>
                            <svg t="1704705343072" class="icon fill-primary w-6 h-6" viewBox="0 0 1024 1024"
                                 version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5587" width="200" height="200"><path
                                d="M850.367451 513.489934c4.208858-5.538133 8.271384-11.088546 12.139481-16.651238 55.695486-80.095199 69.303412-153.764036 38.315654-207.435423-30.986735-53.671387-101.583606-78.719876-198.802812-70.535473-6.750751 0.568958-13.588483 1.310855-20.488637 2.187829-2.691295-6.414083-5.467525-12.70844-8.350179-18.838044-41.517579-88.280626-98.512664-136.898927-160.487158-136.898927-61.974493 0-118.969579 48.618301-160.485111 136.898927-2.883677 6.130627-5.658883 12.423961-8.350179 18.839067-6.901177-0.876973-13.739932-1.61887-20.490683-2.187829-97.209996-8.18645-167.813007 16.865109-198.800765 70.535473-30.987758 53.671387-17.380856 127.340223 38.314631 207.435423 3.867074 5.561669 7.9296 11.113105 12.139481 16.651238-4.209882 5.538133-8.271384 11.088546-12.139481 16.651238-55.694463 80.095199-69.301366 153.764036-38.314631 207.434399 27.13808 47.004547 84.658122 72.055083 163.830299 72.055083 11.228739 0 22.897499-0.50449 34.970466-1.51961 6.750751-0.568958 13.589506-1.310855 20.490683-2.187829 2.691295 6.414083 5.467525 12.70844 8.351202 18.839067 41.515532 88.281649 98.510618 136.89995 160.485111 136.89995 61.974493 0 118.969579-48.618301 160.487158-136.89995 2.883677-6.130627 5.658883-12.423961 8.350179-18.839067 6.900154 0.876973 13.737886 1.61887 20.488637 2.187829 12.081153 1.01819 23.737634 1.51961 34.972513 1.51961 79.162968 0 136.693242-25.052582 163.830299-72.055083 30.986735-53.670363 17.379832-127.3392-38.315654-207.434399C858.639858 524.579503 854.577333 519.028067 850.367451 513.489934zM705.378266 258.742972c79.704296-6.715959 138.322345 11.755742 160.790056 50.669006 22.467711 38.914288 9.157567 98.901521-36.513612 164.583452-1.775436 2.554172-3.603061 5.106298-5.459339 7.656377-27.969005-31.598672-61.164035-62.346977-98.369402-91.212398-6.39464-46.653553-16.426111-90.774423-29.806863-130.796952C699.155541 259.309884 702.278671 259.003915 705.378266 258.742972zM603.368964 670.542876c-30.015617 17.32969-60.426231 32.621978-90.675162 45.690622-30.248931-13.068643-60.659545-28.360931-90.675162-45.690622-30.015617-17.32969-58.46353-36.019355-84.905762-55.680137-3.805676-32.730449-5.767354-66.712401-5.767354-101.371782 0-34.659381 1.961678-68.64338 5.768377-101.373829 26.442232-19.660782 54.890144-38.350446 84.904739-55.680137 30.015617-17.32969 60.427254-32.621978 90.675162-45.690622 30.248931 13.068643 60.658522 28.360931 90.675162 45.690622 30.016641 17.32969 58.464553 36.020378 84.907809 55.68116 3.805676 32.730449 5.768377 66.713424 5.768377 101.372805 0 34.659381-1.961678 68.641333-5.767354 101.370759C661.833517 634.522498 633.385605 653.213185 603.368964 670.542876zM679.918407 669.814282c-6.14393 32.457226-14.217816 63.196321-24.11728 91.542926-29.498848-5.600555-60.157101-13.977339-91.338265-24.885783 19.729344-9.582239 39.413662-20.017916 58.912761-31.275307C642.875746 693.938726 661.755746 682.109306 679.918407 669.814282zM460.924741 736.471424c-31.181163 10.908444-61.839417 19.285229-91.337241 24.885783-9.898441-28.346605-17.972327-59.0857-24.116257-91.541903 18.162662 12.295024 37.041638 24.12342 56.539714 35.380812C421.510056 716.454532 441.194374 726.889185 460.924741 736.471424zM293.701159 580.147076c-25.037233-21.548782-47.620577-43.911092-67.219961-66.657142 19.599384-22.74605 42.183751-45.108361 67.219961-66.658166-1.566682 21.877263-2.371 44.142359-2.371 66.658166C291.330158 536.00574 292.134477 558.269813 293.701159 580.147076zM345.471242 357.163539c6.14393-32.457226 14.217816-63.195298 24.116257-91.541903 29.497824 5.600555 60.156078 13.977339 91.336218 24.885783-19.729344 9.582239-39.413662 20.016893-58.912761 31.275307C382.511857 333.040119 363.633904 344.868515 345.471242 357.163539zM564.463885 290.50742c31.18014-10.907421 61.838394-19.284205 91.337241-24.885783 9.898441 28.346605 17.97335 59.0857 24.11728 91.542926-18.162662-12.295024-37.042661-24.124444-56.541761-35.381835C603.877547 310.524313 584.193229 300.088636 564.463885 290.50742zM731.688491 446.832791c25.036209 21.548782 47.620577 43.911092 67.219961 66.657142-19.599384 22.745027-42.182728 45.107337-67.219961 66.656119 1.566682-21.87624 2.371-44.141336 2.371-66.656119C734.059492 490.974128 733.255173 468.710055 731.688491 446.832791zM388.417357 219.247446c34.046421-72.393797 79.343069-113.913423 124.276445-113.913423s90.230024 41.519626 124.275421 113.913423c1.324158 2.815115 2.619664 5.67321 3.900843 8.55484-41.349757 8.422833-84.576257 21.796422-128.176264 39.584554-43.600007-17.788132-86.826508-31.16172-128.176264-39.584554C385.798716 224.919632 387.094222 222.061538 388.417357 219.247446zM195.73494 473.994408c-45.672202-65.680908-58.980299-125.669164-36.513612-164.583452 19.435655-33.662681 65.900919-52.022841 129.693828-52.022841 9.952676 0 20.338211 0.447185 31.096229 1.353834 3.099594 0.260943 6.222725 0.567935 9.359158 0.899486-13.379729 40.021505-23.411199 84.142375-29.806863 130.794905-37.205367 28.865421-70.400397 59.613726-98.370425 91.213421C199.338001 479.099682 197.510376 476.54858 195.73494 473.994408zM320.010361 768.235872c-79.70839 6.711865-138.322345-11.754718-160.790056-50.667983-22.466688-38.913265-9.157567-98.902544 36.513612-164.582429 1.775436-2.554172 3.603061-5.105275 5.458315-7.655354 27.970028 31.598672 61.165058 62.346977 98.370425 91.211375 6.39464 46.65253 16.426111 90.7734 29.806863 130.794905C326.234109 767.667937 323.109955 767.974929 320.010361 768.235872zM636.969223 807.733445c-34.046421 72.392774-79.343069 113.912399-124.275421 113.912399s-90.230024-41.519626-124.276445-113.912399c-1.324158-2.815115-2.620687-5.674233-3.900843-8.556886 41.35078-8.422833 84.577281-21.797445 128.177288-39.585577 43.601031 17.788132 86.827531 31.16172 128.177288 39.584554C639.58991 802.059212 638.293381 804.918329 636.969223 807.733445zM866.168322 717.567889c-22.467711 38.913265-81.075527 57.387012-160.790056 50.667983-3.099594-0.260943-6.222725-0.567935-9.359158-0.899486 13.380752-40.021505 23.412223-84.143399 29.806863-130.795928 37.205367-28.864398 70.399373-59.612703 98.369402-91.210351 1.855254 2.550079 3.682879 5.102205 5.459339 7.656377C875.325889 618.667392 888.633986 678.654624 866.168322 717.567889z"></path></svg>
                        </span>
                    </label>
                </div>
                <div class="drawer-side">
                    <label for="auto-edit" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                        <div class="flex justify-between items-center mb-4">
                            <div class="text-xl font-medium">自动修改标签</div>
                            <button class="btn btn-sm btn-primary" @click="handleBatchAuto">保存</button>
                        </div>
                        <p>根据元数据中的标题、艺术家、专辑和文件名、文件完整路径进行匹配。</p>
                        <p class="mb-2">标题、艺术家、专辑每一项匹配等级指标：完全一致，包含，不匹配</p>
                        <div class="form-control w-24">
                            <label class="label cursor-pointer">
                                <input type="radio" name="radio-auto-mode" class="radio checked:bg-red-500" value="simple" v-model="selectAutoMode"/>
                                <span class="label-text tooltip tooltip-right" data-tip="至少存在一个完全一致和一个包含，但也优先选完全一致">宽松模式</span>
                            </label>
                        </div>
                        <div class="form-control w-24">
                            <label class="label cursor-pointer">
                                <input type="radio" name="radio-auto-mode" class="radio checked:bg-blue-500" value="normal" v-model="selectAutoMode"/>
                                <span class="label-text tooltip tooltip-right" data-tip="三个指标必须为包含或完全一致，但也优先选完全一致">标准模式</span>
                            </label>
                        </div>
                        <div class="form-control w-24">
                            <label class="label cursor-pointer">
                                <input type="radio" name="radio-auto-mode" class="radio checked:bg-blue-500" value="hard" v-model="selectAutoMode"/>
                                <span class="label-text tooltip tooltip-right" data-tip="三个指标必须都为完全一致">严格模式</span>
                            </label>
                        </div>
                        <div class="mt-2">音乐源顺序:</div>
                        <multi-select :options="resourceListBatch" v-model="sourceList"></multi-select>
                        <div class="mt-2">修改范围:</div>
                        <multi-select :options="modifyListBatch" v-model="modifyList"></multi-select>
                        <div class="mt-2">原有音乐标签将被保留，不会被修改或覆盖:</div>
                        <div class="flex items-center">
                            <input type="checkbox" class="toggle toggle-primary mr-2" v-model="isSkipTag"/>
                            <div v-if="isSkipTag">是</div>
                            <div v-else>否</div>
                        </div>
                        <div class="mt-2">包含音乐文件的目录都被解释为同一个专辑，专辑名称为文件夹名:</div>
                        <div>当元数据中不存在专辑信息，用于补充专辑信息，提高匹配度</div>
                        <div class="flex items-center">
                            <input type="checkbox" class="toggle toggle-primary mr-2" v-model="isFolderAlbum"/>
                            <div v-if="isFolderAlbum">是</div>
                            <div v-else>否</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 100%;display: flex;margin-top: 10px;">
            <div class="drawer">
                <input id="tidy-folder" type="checkbox" class="drawer-toggle" name='tidy-folder'
                       v-model="tidyFolderCheckBox"/>
                <div class="drawer-content">
                    <!-- Page content here -->
                    <label for="tidy-folder" class="btn btn-sm drawer-button" v-bk-tooltips="'整理文件'">
                        <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                        <span v-else>
                            <svg t="1704703799284" class="icon fill-current w-6 h-6" viewBox="0 0 1024 1024"
                                 version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11364" width="200" height="200"><path
                                d="M379.904 677.888l251.904 0c21.504 0 43.008-17.408 43.008-43.008l0-43.008c0-21.504-17.408-43.008-43.008-43.008L379.904 548.864c-21.504 0-43.008 17.408-43.008 43.008l0 43.008C336.896 661.504 354.304 677.888 379.904 677.888zM379.904 596.992l251.904 0 0 43.008L379.904 640 379.904 596.992zM921.6 303.104l-80.896 0-29.696-94.208c-13.312-43.008-55.296-72.704-102.4-59.392l-128 33.792L413.696 84.992c-43.008-21.504-94.208-8.192-114.688 29.696L192.512 303.104l-21.504 0L84.992 303.104c-21.504 0-43.008 17.408-43.008 43.008l0 84.992c0 21.504 17.408 43.008 43.008 43.008l43.008 0 0 456.704c0 21.504 17.408 43.008 43.008 43.008l665.6 0c21.504 0 43.008-17.408 43.008-43.008l0-460.8L921.6 470.016c21.504 0 43.008-17.408 43.008-43.008l0-84.992C960.512 324.608 943.104 303.104 921.6 303.104zM720.896 192.512c21.504-4.096 47.104 8.192 51.2 29.696l21.504 84.992-4.096 0-55.296-29.696 8.192 0-12.288-38.912-38.912 13.312 0 8.192-51.2-29.696 0-17.408L720.896 192.512zM708.608 303.104 431.104 303.104l68.608-119.808L708.608 303.104zM332.8 136.192c13.312-21.504 37.888-25.6 55.296-17.408l72.704 43.008-76.8 141.312-94.208 0-4.096 0 0 0-47.104 0L332.8 136.192zM836.608 929.792l-665.6 0 0-460.8 665.6 0L836.608 929.792zM921.6 427.008 84.992 427.008l0-84.992 831.488 0 0 84.992L921.6 427.008zM366.592 251.904l-38.912-21.504L307.2 264.192l33.792 21.504L366.592 251.904zM405.504 179.2l-33.792-21.504-21.504 33.792 33.792 21.504L405.504 179.2z"></path></svg>
                        </span>
                    </label>
                </div>
                <div class="drawer-side">
                    <label for="tidy-folder" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                        <div class="flex justify-between items-center mb-4">
                            <div class="text-xl font-medium">整理文件</div>
                            <button class="btn btn-sm btn-primary" @click="handleTidy">保存</button>
                        </div>
                        <p>整理文件夹，按一级目录，二级目录选定的信息分类</p>
                        <div>整理后的根目录</div>
                        <div class="input-demo">
                            <input type="text" placeholder="Type here"
                                   class="input input-sm input-bordered w-full max-w-xs"
                                   v-model="tidyFormData.root_path"/>
                        </div>
                        <div v-for="(input, index) in tidyFormData.dir_list" :key="index"
                             style="margin-top: 10px;">
                            <div>第{{ index + 1 }}层目录</div>
                            <div class="flex">
                                <single-select v-model="input.value"
                                               :options="tidyList"
                                               :placeholder="'请选择'"
                                >
                                </single-select>
                                <button class="btn btn-sm ml-1" @click="removeInput(index)">x</button>

                            </div>
                            <div v-if="input.value === 'custom'">
                                <div>自定义变量：</div>
                                <input type="text" placeholder="请输入自定义变量，例如：${artist}-${album}"
                                       class="input input-sm input-bordered w-full max-w-xs" v-model="input.value2"/>
                            </div>
                        </div>
                        <button class="btn btn-sm mt-2" @click="addInput">添加目录</button>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 100%;display: flex;margin-top: 10px;">
            <button :theme="'success'" @click="handleChangeLanguage('sim2trad')"
                    class="mr10 btn btn-sm"
                    v-bk-tooltips="'简体转繁体'"
                    :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else>
                    <svg t="1704703866798" class="icon w-6 h-6 fill-primary" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="12326" width="200" height="200"><path
                        d="M716.8 76.8a230.4 230.4 0 0 1 230.4 230.4v409.6a230.4 230.4 0 0 1-230.4 230.4H307.2a230.4 230.4 0 0 1-230.4-230.4V307.2a230.4 230.4 0 0 1 230.4-230.4h409.6m0-76.8H307.2A307.2 307.2 0 0 0 0 307.2v409.6a307.2 307.2 0 0 0 307.2 307.2h409.6a307.2 307.2 0 0 0 307.2-307.2V307.2A307.2 307.2 0 0 0 716.8 0z"
                        p-id="12327"></path><path
                        d="M319.744 309.76l-19.2 22.272h202.752c0 23.808 0 45.824-1.792 66.304h34.56v39.936h-37.632c0 9.472-2.304 21.248-4.864 35.584h23.296v32.512H486.4l-3.072 10.496 17.152 13.056a763.136 763.136 0 0 1-96 39.936l118.784-4.352c20.736-10.752 46.592-25.6 76.8-41.728l44.8 29.44a984.32 984.32 0 0 1-222.464 92.16q102.4-4.096 220.672-12.288c-17.152-13.056-30.208-22.528-39.424-28.416l44.288-28.16a1037.056 1037.056 0 0 1 136.448 97.792l-51.2 34.304c-11.52-11.008-25.6-24.064-44.288-39.424l-146.688 8.704v68.096c0 34.56-20.224 51.2-60.928 51.2h-54.016l-11.008-51.2a478.976 478.976 0 0 0 49.664 3.072 15.616 15.616 0 0 0 17.92-17.152v-51.2c-62.464 3.328-128 5.888-200.96 7.936l-13.568-51.2c17.152 1.28 34.304 1.792 51.2 1.792a784.64 784.64 0 0 0 128-39.936l-131.584 5.12-9.728-45.824a146.176 146.176 0 0 0 47.872-5.376 798.464 798.464 0 0 0 75.52-33.792l3.84-13.056h-174.848c4.864-30.208 8.192-52.992 10.24-68.096H232.448v-39.936h42.496c2.304-20.48 4.096-35.84 4.864-46.08l-19.712 17.152-33.28-39.168a329.984 329.984 0 0 0 86.784-102.4l52.736 11.776-15.36 27.136h177.664v43.008z m108.032 419.84a727.808 727.808 0 0 1-167.68 64l-23.296-49.152A623.104 623.104 0 0 0 394.752 691.2z m-106.24-296.96l-6.656 41.216h87.04a390.912 390.912 0 0 0-61.952-21.504l12.8-19.712z m41.728-68.608H330.24l-4.352 40.96h76.8a337.92 337.92 0 0 0-53.504-20.992z m44.288 109.824h35.584l6.912-41.216h-86.784a512 512 0 0 1 57.856 20.48z m44.8-68.864l1.792-40.96h-83.456a358.4 358.4 0 0 1 55.808 22.016l-12.288 18.944z m119.296-33.024q-9.216 11.264-27.648 30.72l-33.792-40.704a412.16 412.16 0 0 0 82.176-135.68l54.272 12.288-19.2 43.008h157.952v51.2h-34.304a284.928 284.928 0 0 1-51.2 107.52 469.248 469.248 0 0 0 98.304 43.776l-28.928 51.2a460.8 460.8 0 0 1-108.288-55.808 294.656 294.656 0 0 1-111.104 52.736l-28.928-45.568a270.336 270.336 0 0 0 99.072-43.008 237.568 237.568 0 0 1-48.384-71.68zM614.4 688.896A1068.032 1068.032 0 0 1 781.824 742.4l-32 51.2a926.464 926.464 0 0 0-168.448-57.088z m-9.216-358.4a180.736 180.736 0 0 0 51.2 76.8 244.736 244.736 0 0 0 41.728-76.8z"
                        p-id="12328"></path></svg>
                </span>
            </button>
        </div>
        <div style="width: 100%;display: flex;margin-top: 10px;">
            <button :theme="'success'" @click="handleChangeLanguage('trad2sim')"
                    class="mr10 btn btn-sm"
                    v-bk-tooltips="'繁体转简体'"
                    :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else>
                    <svg t="1704703916417" class="icon fill-current w-6 h-6" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="1378" width="200" height="200"><path
                        d="M716.8 76.8a230.4 230.4 0 0 1 230.4 230.4v409.6a230.4 230.4 0 0 1-230.4 230.4H307.2a230.4 230.4 0 0 1-230.4-230.4V307.2a230.4 230.4 0 0 1 230.4-230.4h409.6m0-76.8H307.2A307.2 307.2 0 0 0 0 307.2v409.6a307.2 307.2 0 0 0 307.2 307.2h409.6a307.2 307.2 0 0 0 307.2-307.2V307.2A307.2 307.2 0 0 0 716.8 0z"
                        p-id="1379"></path><path
                        d="M335.616 322.048a489.728 489.728 0 0 1-48.384 68.352L232.96 355.328a366.848 366.848 0 0 0 78.08-128l61.44 13.568-9.728 25.6H512v55.808h-76.8a300.288 300.288 0 0 1 29.44 48.64l-56.32 21.504a535.296 535.296 0 0 0-39.424-70.144z m-61.952 143.36h63.744v332.8h-63.744z m79.104-97.792a628.48 628.48 0 0 1 73.728 76.8l-47.104 32.512A768 768 0 0 0 307.2 396.544z m45.056 122.368h235.264v241.92h-235.264z m60.672 94.464h114.944v-43.008h-114.944z m114.944 94.72V634.88h-114.944v44.288zM636.672 793.6l-15.36-57.856 54.016 2.048c12.8 0 19.2-8.96 19.2-25.6v-261.12h-223.744v-58.368H757.76V729.6c0 43.264-23.296 65.024-70.144 65.024z m-39.168-471.552a491.008 491.008 0 0 1-37.632 59.648l-54.016-35.072a338.432 338.432 0 0 0 63.232-119.808l60.928 13.568c-4.096 11.52-6.912 20.224-8.704 25.6h169.728v55.808h-88.064a332.8 332.8 0 0 1 27.136 43.776l-56.576 21.504a533.504 533.504 0 0 0-37.376-65.28z"
                        p-id="1380"></path></svg>
                </span>
            </button>
        </div>
        <div style="width: 100%;display: flex;margin-top: 10px;">
            <button :theme="'success'" onclick="remove_folder.showModal()"
                    class="mr10 btn btn-sm"
                    v-bk-tooltips="'删除文件夹'"
                    :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else>
                    <svg t="1711691137581" class="icon fill-primary w-6 h-6" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="2478" width="200" height="200"><path
                        d="M202.666667 256h-42.666667a32 32 0 0 1 0-64h704a32 32 0 0 1 0 64H266.666667v565.333333a53.333333 53.333333 0 0 0 53.333333 53.333334h384a53.333333 53.333333 0 0 0 53.333333-53.333334V352a32 32 0 0 1 64 0v469.333333c0 64.8-52.533333 117.333333-117.333333 117.333334H320c-64.8 0-117.333333-52.533333-117.333333-117.333334V256z m224-106.666667a32 32 0 0 1 0-64h170.666666a32 32 0 0 1 0 64H426.666667z m-32 288a32 32 0 0 1 64 0v256a32 32 0 0 1-64 0V437.333333z m170.666666 0a32 32 0 0 1 64 0v256a32 32 0 0 1-64 0V437.333333z"></path></svg>
                </span>
            </button>
        </div>
        <div style="width: 100%;display: flex;margin-top: 10px;">
            <div class="drawer">
                <input id="split-filename" type="checkbox" class="drawer-toggle" name='split-filename'
                       v-model="splitFilenameCheckBox"/>
                <div class="drawer-content">
                    <!-- Page content here -->
                    <label for="split-filename" class="btn btn-sm drawer-button" v-bk-tooltips="'拆分元数据'">
                        <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                        <span v-else>
                            <svg t="1704704161763" class="icon fill-current w-6 h-6" viewBox="0 0 1024 1024" version="1.1"
                                 xmlns="http://www.w3.org/2000/svg" p-id="3671" width="200" height="200"><path
                                d="M912 64v256H112V64h66.688v192h666.688V64zM112 960v-256h800v256h-66.624v-192H178.688v192zM64 448h128v128H64zM832 448h128v128h-128zM256 448h128v128H256zM448 448h128v128H448zM640 448h128v128h-128z"></path></svg>
                        </span>
                    </label>
                </div>
                <div class="drawer-side">
                    <label for="split-filename" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                        <div class="flex justify-between items-center mb-4">
                            <div class="text-xl font-medium">拆分元数据</div>
                            <button class="btn btn-sm btn-primary" @click="splitFilenameFunc">保存</button>
                        </div>
                        <div>将文件名称按正则匹配规则提取出来并赋值给艺术家，专辑，标题</div>
                        <div class="mt-2">
                            <div>修改范围：</div>
                            <select class="select select-bordered select-sm w-full max-w-xs" @change="handleExtractChange"
                                    v-model="extractField">
                                <option v-for="option in extractList"
                                        :key="option.id"
                                        :id="option.id"
                                        :value="option.id"
                                        class="bg-base-100">
                                    {{ option.name }}
                                </option>
                            </select>
                            <div>拆分规则：</div>
                            <div v-for="(item, index) in ruleList" :key="index" class="flex justify-center items-center">
                                <div class="mr-2">{{ index + 1 }}.</div>
                                <input type="text" placeholder="请输入" class="input input-bordered w-full max-w-xs input-sm mt-1"
                                       v-model="ruleList[index]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 100%;display: flex;margin-top: 10px;">
            <div class="drawer">
                <input id="replace-text" type="checkbox" class="drawer-toggle"/>
                <div class="drawer-content">
                    <!-- Page content here -->
                    <label for="replace-text" class="btn btn-sm drawer-button" v-bk-tooltips="'替换文本'">
                        <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                        <span v-else>
                            <svg t="1704704397351" class="icon fill-primary w-6 h-6" viewBox="0 0 1024 1024"
                                 version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4654" width="200" height="200"><path
                                d="M418.24 448h-55.296l-39.488-105.984h-161.28L124.992 448h-55.296L217.216 60.736h53.504L418.24 448zM307.968 298.24l-58.496-160.96a180.352 180.352 0 0 1-6.016-27.008h-1.28c-1.792 11.648-3.84 20.608-6.208 27.008L177.984 298.24h129.984zM668.288 960V568.512h136c40.64 0 73.152 8.192 97.344 24.64 24.32 16.448 36.48 38.272 36.48 65.344 0 21.568-7.232 40.576-21.696 57.152-14.464 16.512-34.304 28.16-59.648 35.136v1.024c31.488 3.008 56.64 13.056 75.52 30.208 18.816 17.152 28.16 38.784 28.16 65.088 0 33.728-14.272 60.992-42.88 81.792-28.416 20.736-65.088 31.104-109.696 31.104h-139.584z m59.84-347.264v122.56h54.4c28.864 0 51.584-5.952 67.968-17.792a57.6 57.6 0 0 0 24.704-49.408c0-36.864-29.056-55.296-87.232-55.296h-59.84z m0 166.592v136.448h71.68c31.232 0 55.424-6.08 72.512-18.304a59.072 59.072 0 0 0 25.472-50.944c0-44.8-35.968-67.2-107.904-67.2h-61.76zM448 858.24l6.4-37.76A349.632 349.632 0 0 1 192 512h64a288.64 288.64 0 0 0 209.92 245.76l9.6-53.76 119.68 101.12-147.2 53.12z"></path></svg>
                        </span>
                    </label>
                </div>
                <div class="drawer-side">
                    <label for="replace-text" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                        <div class="flex justify-between items-center mb-4">
                            <div class="text-xl font-medium">替换文本</div>
                            <button class="btn btn-sm btn-primary" @click="replaceTextFunc">保存</button>
                        </div>
                        <div>
                            <div>
                                <div class="text-gray-400">将一些藏在元数据的无关信息清除，</div>
                                <div class="text-gray-400">支持文本替换和正则表达式替换</div>
                            </div>
                            <div class="mt-2">替换模式</div>
                            <single-select v-model="replaceMode"
                                           :options="replaceOptions"
                                           :placeholder="'请输入搜索关键词, 按Enter确认'"
                            >
                            </single-select>
                            <div>修改范围</div>
                            <multi-select :options="modifyListLanguage" v-model="modifyListL"></multi-select>
                            <div class="mt-2">
                                <div v-for="(item, index) in replaceTextList" :key="index"
                                     class="flex justify-center items-center mb-1">
                                    <div class="mr-2">{{ index + 1 }}.</div>
                                    <input type="text" placeholder="替换前"
                                           class="input input-bordered w-full max-w-xs input-sm mt-1"
                                           v-model="item.before"/>
                                    <input type="text" placeholder="替换后"
                                           class="input input-bordered w-full max-w-xs input-sm mt-1"
                                           v-model="item.after"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="width: 100%;display: flex;margin-top: 10px;">
            <div class="drawer">
                <input id="change-format" type="checkbox" class="drawer-toggle"/>
                <div class="drawer-content">
                    <!-- Page content here -->
                    <label for="change-format" class="btn btn-sm drawer-button" v-bk-tooltips="'格式转换'">
                        <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                        <span v-else>
                            <svg t="1704704621435" class="icon fill-current w-6 h-6" viewBox="0 0 1024 1024"
                                 version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3438" width="200" height="200"><path
                                d="M136.192 986.112C66.56 986.112 10.24 927.744 10.24 856.576v-141.312c0-71.68 56.32-130.048 125.952-130.048h241.664c69.632 0 125.952 58.368 125.952 130.048v141.312c0 71.68-56.32 130.048-125.952 130.048H136.192z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272v-141.312c0-29.696-23.552-54.272-52.224-54.272H136.192z m485.888 308.736c-19.968 0-31.232-15.872-31.744-31.232-0.512-14.848 8.192-32.768 35.84-35.328 26.112-4.608 46.08-8.704 70.144-16.896l1.024-0.512h1.024c9.216 0 40.448-22.528 66.56-53.76l0.512-1.024 1.536-1.024h0.512c14.336-7.168 38.912-48.64 51.712-96.256 0.512-3.072 1.024-5.632 1.536-8.192l0.512-2.56c3.072-16.896 6.144-31.744 6.144-49.152 0-2.048 0-5.12-0.512-10.24-0.512-3.072-0.512-5.632-0.512-8.704l-37.376 45.568c-9.728 10.752-18.944 12.8-25.088 12.8-4.096 0-8.704-1.024-12.8-3.072-9.728-5.12-15.36-11.776-17.408-20.48-2.56-11.264 3.584-21.504 6.144-25.088l0.512-0.512 84.992-105.472c3.072-3.072 20.48-19.456 38.912-19.456 26.112 0 40.448 23.04 44.032 29.184l76.288 110.08s12.288 17.408-9.216 39.936c-7.168 7.168-15.36 11.264-23.04 11.264-9.728 0-15.872-5.632-16.896-6.656l-42.496-56.832v16.896c0 60.928-20.48 119.808-60.928 175.104-40.448 50.688-86.528 83.456-140.8 101.376-2.048 1.024-5.12 2.048-13.312 4.096l-4.096 1.024c-12.288 3.072-23.552 5.12-33.28 6.656h-18.432z m-456.704-451.584c-28.672 0-43.008-26.624-44.544-30.208l-71.68-113.152s-12.288-17.408 9.216-39.424c7.68-7.168 15.36-11.264 23.04-11.264 9.728 0 15.872 5.632 16.896 6.656l42.496 56.32v-1.536-6.144c0.512-25.6 3.584-51.2 8.704-75.776 11.776-48.64 38.912-94.208 82.432-139.776 41.984-38.912 90.624-64 139.776-72.192 17.408-4.608 34.816-4.608 52.224-4.608 9.728 0 15.36 13.312 15.872 26.112 1.024 17.92-7.68 37.888-35.84 40.96l-2.048 0.512c-19.968 4.096-40.448 8.192-59.904 16.384-38.4 15.872-67.584 39.936-94.72 76.8l-4.608 6.656-2.048-1.536c-6.144 8.704-20.992 35.84-28.672 71.168l-0.512 3.072-0.512 1.536v0.512c-0.512 2.048-5.12 25.088-5.12 51.2v4.096c0 3.072 0.512 6.656 0.512 9.728 0 1.536 0 2.56 0.512 4.096l33.792-40.96c9.728-10.752 18.944-12.8 25.088-12.8 4.608 0 8.704 1.024 12.8 3.072 9.728 5.12 15.36 11.776 17.408 19.968 1.536 7.68-0.512 16.896-6.144 25.088v0.512L204.8 498.176c-3.584 3.584-20.992 19.968-39.424 19.968z m471.04-42.496c-69.632 0-125.952-58.368-125.952-130.048V204.8c0-71.68 56.32-130.048 125.952-130.048h241.152C947.2 74.752 1003.52 133.12 1003.52 204.8v141.312c0 71.68-56.32 130.048-125.952 130.048h-241.152z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272V204.8c0-29.696-23.552-54.272-52.224-54.272h-241.152z"></path></svg>
                        </span>
                    </label>
                </div>
                <div class="drawer-side">
                    <label for="change-format" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                        <div class="flex justify-between items-center mb-4">
                            <div class="text-xl font-medium">格式转换</div>
                            <button class="btn btn-sm btn-primary" @click="formatMusicFunc">保存</button>
                        </div>
                        <div>
                            <div>
                                <div class="text-gray-400">将音频转换成其他格式，保存在同目录下。</div>
                                <div class="text-gray-400">不会删除源文件</div>
                                <div class="text-gray-400">需要下载<a href="https://johnvansickle.com/ffmpeg/"
                                                                  target="_blank" style="color: blue;">ffmpeg</a>可执行文件
                                </div>
                                <div class="text-gray-400">放置在挂载的 /app/data/bin/ 目录下</div>
                            </div>

                            <div style="margin-top: 10px;margin-bottom: 5px;">目标格式</div>
                            <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectFormat">
                                <option v-for="option in formatList" :key="'format' + option.id"
                                        :id="option.id"
                                        :name="option.name"
                                        :value="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                            <div style="margin-top: 10px;margin-bottom: 5px;">比特率</div>
                            <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectBitRate">
                                <option v-for="option in bitRateList" :key="'format' + option.id"
                                        :id="option.id"
                                        :name="option.name"
                                        :value="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                            <div v-if="selectBitRate === 'custom'">
                                <div style="margin-top: 10px;margin-bottom: 5px;">自定义</div>
                                <input type="text" placeholder="请输入自定义的比特率"
                                       class="input input-bordered input-sm w-full max-w-xs"
                                       v-model="selectBitRateCustom"/>
                            </div>

                            <div style="margin-top: 10px;margin-bottom: 5px;">采样率</div>
                            <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectSampleRate">
                                <option v-for="option in sampleRateList" :key="'format' + option.id"
                                        :id="option.id"
                                        :name="option.name"
                                        :value="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                            <div v-if="selectSampleRate === 'custom'">
                                <div style="margin-top: 10px;margin-bottom: 5px;">自定义</div>
                                <input type="text" placeholder="请输入自定义的采样率"
                                       class="input input-bordered input-sm w-full max-w-xs"
                                       v-model="selectSampleRateCustom"/>
                                <p class="text-gray-400 text-sm">必须是目标格式支持的有效采样率值，否则将转换失败。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="width: 100%;display: flex;margin-top: 10px;">
            <button :theme="'success'" onclick="split_cue.showModal()"
                    class="mr10 btn btn-sm"
                    v-bk-tooltips="'分割音轨'"
                    :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else>
                    <svg t="1704704874297" class="icon fill-primary w-6 h-6" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="14186" width="200" height="200"><path
                        d="M64.303027 735.848231l373.080044 0L437.38307 288.150746 64.303027 288.150746 64.303027 735.848231zM114.046964 337.894683l273.591145 0 0 348.208587-273.591145 0L114.046964 337.894683zM586.614883 288.150746l0 447.697485 373.081067 0L959.69595 288.150746 586.614883 288.150746zM909.953036 686.104293l-273.591145 0L636.361891 337.894683l273.591145 0L909.953036 686.104293zM561.742403 114.046453c0-27.470655-22.2477-49.743938-49.742914-49.743938-27.446096 0-49.743938 22.273283-49.743938 49.743938 0 18.404162 10.014074 34.461883 24.87248 43.065841L487.128031 866.886683c-14.858406 8.603959-24.87248 24.662703-24.87248 43.065841 0 27.471678 22.297842 49.743938 49.743938 49.743938 27.495214 0 49.742914-22.273283 49.742914-49.743938 0-18.412348-10.000771-34.477232-24.87248-43.079144L536.869922 157.125597C551.741631 148.524708 561.742403 132.459824 561.742403 114.046453z"
                        p-id="14187"></path></svg>
                </span>
            </button>
        </div>
        <div style="width: 100%;display: flex;margin-top: 10px;" v-if="getUserRole === 'V2'">
            <button :theme="'success'" onclick="import_music.showModal()"
                    class="mr10 btn btn-sm"
                    v-bk-tooltips="'导入收藏'"
                    :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else>
                    <svg t="1710485723470" class="fill-current w-6 h-6" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="5120" width="200" height="200"><path
                        d="M258.701056 193.045226l512.00016 0 0 63.99952L258.701056 257.044746 258.701056 193.045226zM256.993602 321.671065l511.99916 0 0 63.99952L256.993602 385.670585 256.993602 321.671065zM256.993602 449.663108l131.31098 0 0 64.00052L256.993602 513.663628 256.993602 449.663108zM256.993602 577.665147l57.948456 0 0 64.00052-57.948456 0L256.993602 577.665147zM898.701256 0 130.701016 0C95.356326 0 66.702495 28.653831 66.702495 64.00052l0 895.998281c0 35.34469 28.653831 63.99952 63.99952 63.99952l299.403191-0.327895 0-63.99952-299.403191 0.327895L130.702015 64.00052l768.00024 0 0 611.622281 63.99952 0L962.701775 64.00052C962.700776 28.653831 934.041947 0 898.701256 0L898.701256 0z"></path><path
                        d="M962.700776 998.077615c-4.265635-63.979527-29.857446-375.345889-362.549984-392.40643l0-98.101607c0-4.265635 0-17.06154-8.53027-29.857446s-25.591811-12.795905-46.917986-4.265635l-4.265635 0-187.672945 204.734485c-4.265635 4.265635-21.326176 25.591811-21.326176 46.917986 0 25.591811 21.326176 46.917986 25.591811 46.917986l187.672945 213.264755c4.265635 4.265635 17.06154 17.06154 29.857446 17.06154 12.795905 0 21.326176-8.53027 25.591811-17.06154 4.265635-8.53027 4.265635-17.06154 4.265635-29.857446L604.417426 831.731846c55.449256 0 208.99912 8.53027 302.836092 174.877039 6.536908 14.430382 17.06154 17.06154 25.591811 17.06154l8.53027 0 6.380958-1.880398C960.551464 1017.524392 962.700776 1002.34325 962.700776 998.077615L962.700776 998.077615zM617.212332 789.078495c-21.326176 0-34.122081 0-34.122081 0l-21.326176 4.265635 0 145.019594L391.151671 742.160509c-4.265635-4.265635-12.795905-12.795905-12.795905-17.06154 0-4.265635 4.265635-12.795905 8.53027-17.06154l166.346769-179.142674 0 123.693418 21.326176 0c238.856566 0 311.366363 162.081134 332.692538 272.978647C809.149912 801.8744 676.926224 789.078495 617.212332 789.078495L617.212332 789.078495z"></path></svg>
                </span>
            </button>
        </div>
        <div style="width: 100%;display: flex;margin-top: 10px;">
            <button :theme="'success'" onclick="fix_encoding.showModal()"
                    class="mr10 btn btn-sm"
                    v-bk-tooltips="'乱码修复'"
                    :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else>
                    <svg t="1710989442413" class="fill-primary w-6 h-6" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="10872" width="200" height="200"><path
                        d="M623.274667 193.991111a346.225778 346.225778 0 0 1 253.383111 333.141333 351.004444 351.004444 0 0 1-6.826667 68.266667l47.786667 25.144889A398.222222 398.222222 0 0 0 621.226667 139.605333zM771.868444 774.712889a344.746667 344.746667 0 0 1-458.979555 20.48l-46.193778 29.127111a396.970667 396.970667 0 0 0 553.301333-24.234667zM199.566222 625.777778a345.543111 345.543111 0 0 1 219.818667-425.870222l-2.048-54.158223A397.653333 397.653333 0 0 0 153.941333 654.222222z"></path><path
                        d="M509.496889 156.558222l114.460444 99.100445L641.820444 83.057778l-132.323555 73.500444zM225.962667 740.807111l26.624-148.935111-157.468445 73.045333 130.844445 75.889778zM860.728889 698.936889l-143.701333 47.331555 139.036444 103.879112 4.664889-151.210667zM500.622222 616.561778h60.643556l15.246222-282.168889h-91.022222L500.622222 616.561778z"></path><path
                        d="M531.000889 707.584m-45.511111 0a45.511111 45.511111 0 1 0 91.022222 0 45.511111 45.511111 0 1 0-91.022222 0Z"></path></svg>
                </span>
            </button>
        </div>
        <div style="width: 100%;display: flex;margin-top: 10px;" v-if="getUserRole === 'V2'">
            <div style="width: 100%;display: flex;margin-top: 10px;">
                <button :theme="'success'" onclick="dup_check.showModal()"
                        class="mr10 btn btn-sm"
                        v-bk-tooltips="'重复文件检查'"
                        :disabled="isLoading">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else>
                        <svg t="1719917369371" class="fill-current w-6 h-6" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="13519" width="200" height="200"><path
                            d="M776.863664 885.326753a104.797861 104.797861 0 1 1 69.751183-26.637055 104.916307 104.916307 0 0 1-69.751183 26.637055z m0-163.520461a58.73576 58.73576 0 1 0 58.73576 58.73576 58.801563 58.801563 0 0 0-58.73576-58.73576z"
                            p-id="13520"></path><path
                            d="M776.863664 1013.47152c-128.4343 0-232.942628-104.495168-232.942628-232.942628s104.495168-232.942628 232.942628-232.942628 232.942628 104.495168 232.942628 232.942628-104.508328 232.942628-232.942628 232.942628z m0-419.823155c-103.034341 0-186.880526 83.833025-186.880526 186.880527s83.833025 186.880526 186.880526 186.880526 186.880526-83.833025 186.880527-186.880526-83.846185-186.854205-186.880527-186.854206z"
                            p-id="13521"></path><path
                            d="M475.946535 1024H155.762287A141.726506 141.726506 0 0 1 14.193708 882.431421V141.568579A141.726506 141.726506 0 0 1 155.762287 0h640.355336a141.726506 141.726506 0 0 1 141.568579 141.568579v328.778121a23.031051 23.031051 0 0 1-46.062102 0V141.568579A95.611762 95.611762 0 0 0 796.117623 46.062102H155.762287A95.611762 95.611762 0 0 0 60.255809 141.568579v740.862842a95.611762 95.611762 0 0 0 95.506478 95.506477h320.184248a23.031051 23.031051 0 0 1 0 46.062102z"
                            p-id="13522"></path><path
                            d="M767.282747 264.422784H190.545754a23.031051 23.031051 0 0 1 0-46.062101h576.736993a23.031051 23.031051 0 0 1 0 46.062101zM762.110631 455.554185H185.373638a23.031051 23.031051 0 0 1 0-46.062102H762.110631a23.031051 23.031051 0 0 1 0 46.062102zM506.623895 634.196175H187.097676a23.031051 23.031051 0 0 1 0-46.062101h319.526219a23.031051 23.031051 0 0 1 0 46.062101zM412.472959 819.102612h-223.730208a23.031051 23.031051 0 0 1 0-46.062102h223.730208a23.031051 23.031051 0 0 1 0 46.062102z"
                            p-id="13523"></path></svg>
                    </span>
                </button>
            </div>
        </div>
        <bk-dialog v-model="exampleSetting2.primary.visible"
                   theme="primary"
                   :mask-close="false"
                   @confirm="handleTidy"
                   :header-position="exampleSetting2.primary.headerPosition"
                   title="整理文件夹">
            <p>整理文件夹，按一级目录，二级目录选定的信息分类</p>
            <div>整理后的根目录</div>
            <div class="input-demo">
                <bk-input v-model="tidyFormData.root_path">
                </bk-input>
            </div>
            <div v-for="(input, index) in tidyFormData.dir_list" :key="index"
                 style="margin-top: 10px;">
                <div>第{{ index + 1 }}层目录</div>
                <div style="display: flex;align-items: center;">
                    <bk-select style="width: 250px;"
                               :placeholder="'请选择目录'"
                               :clearable="false"
                               v-model="input.value">
                        <bk-option v-for="option in tidyList"
                                   :key="option.id"
                                   :id="option.id"
                                   :name="option.name">
                        </bk-option>
                    </bk-select>
                    <div @click="removeInput(index)">
                        <bk-icon type="close" style="font-size: 18px;cursor: pointer;"></bk-icon>
                    </div>
                </div>
                <div v-if="input.value === 'custom'">
                    <div>自定义变量：</div>
                    <bk-input v-model="input.value2" placeholder="请输入自定义变量，例如：${artist}-${album}"></bk-input>
                </div>
            </div>
            <bk-button :theme="'default'" type="submit" :title="'基础按钮'" @click="addInput" class="mr10"
                       style="margin-top: 10px;">
                添加目录
            </bk-button>
        </bk-dialog>
        <bk-dialog v-model="exampleSetting5.primary.visible"
                   theme="primary"
                   :mask-close="false"
                   @confirm="splitFilenameFunc"
                   :header-position="exampleSetting5.primary.headerPosition"
                   :title="'拆分元数据'">
            <div>将文件名称按正则匹配规则提取出来并赋值给艺术家，专辑，标题</div>
            <div class="mt-2">
                <div>修改范围：</div>
                <select class="select select-bordered select-sm w-full max-w-xs" @change="handleExtractChange"
                        v-model="extractField">
                    <option v-for="option in extractList"
                            :key="option.id"
                            :id="option.id"
                            :value="option.id"
                            class="bg-base-100">
                        {{ option.name }}
                    </option>
                </select>
                <div>拆分规则：</div>
                <div v-for="(item, index) in ruleList" :key="index" class="flex justify-center items-center">
                    <div class="mr-2">{{ index + 1 }}.</div>
                    <input type="text" placeholder="请输入" class="input input-bordered w-full max-w-xs input-sm mt-1"
                           v-model="ruleList[index]"/>
                </div>
            </div>
        </bk-dialog>
        <bk-dialog v-model="exampleSetting11.primary.visible"
                   theme="primary"
                   :mask-close="false"
                   @confirm="fixEncodingFunc"
                   :header-position="exampleSetting11.primary.headerPosition"
                   :title="'乱码修复'">
            <div>修复乱码的元数据</div>
            <div>修改范围</div>
            <multi-select :options="modifyListLanguage" v-model="modifyListL"></multi-select>
        </bk-dialog>
        <dialog id="fix_encoding" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">乱码修复</h3>
                <div class="py-4 z-20">
                    <div>修复乱码的元数据</div>
                    <div>修改范围</div>
                    <multi-select :options="modifyListLanguage" v-model="modifyListL"></multi-select>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="fixEncodingFunc">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="dup_check" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">重复文件检查</h3>
                <div class="py-4">
                    <div>
                        <div class="text-gray-400">查找出重复的文件</div>
                        <div class="text-gray-400">不会自动删除您的文件，可以到操作记录中查看重复文件进一步删除操作。</div>
                        <div class="text-gray-400">支持根据hash校验重复和文件名称校验重复</div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="checkForDuplicates">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="import_music" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">导入收藏</h3>
                <div class="py-4">
                    <div>将勾选的音乐导入音乐收藏库</div>
                    <div>
                        <div class="mt-2">跳过已入库的音乐文件:</div>
                        <div class="flex items-center">
                            <input type="checkbox" class="toggle toggle-primary mr-2" v-model="isSkipExist"/>
                            <div v-if="isSkipExist">是</div>
                            <div v-else>否</div>
                        </div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="importMusic">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="split_cue" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">切分音轨</h3>
                <div class="py-4">
                    <div>使用CUE标记文件无损切割整轨CD音轨</div>
                    <div>不会删除源文件</div>
                    <div>需要下载<a href="https://johnvansickle.com/ffmpeg/" target="_blank" style="color: blue;">ffmpeg</a>可执行文件
                    </div>
                    <div>放置在挂载的 /app/data/bin/ 目录下</div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="splitCueFunc">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="trans_font" ref="trans_font" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold" v-if="exampleSetting4.primary.type === 'sim2trad'">简体转繁体</h3>
                <h3 class="text-lg font-bold" v-else>繁体转简体</h3>
                <div class="py-4 z-20">
                    <div>修改范围</div>
                    <multi-select :options="modifyListLanguage" v-model="modifyListL"></multi-select>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="handleChangeLanguageFunc">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="remove_folder" ref="remove_folder" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">删除文件夹</h3>
                <div class="py-4 z-20">
                    <div>删除文件夹或文件</div>
                    <div class="form-control w-72">
                        <label class="label cursor-pointer">
                            <input type="radio" name="radio-10" class="radio checked:bg-accent radio-accent" value="null"
                                   v-model="deleteMode"/>
                            <span class="label-text">删除空文件夹</span>
                        </label>
                    </div>
                    <div class="form-control w-72">
                        <label class="label cursor-pointer">
                            <input type="radio" name="radio-10" class="radio checked:bg-accent radio-accent" value="null_music"
                                   v-model="deleteMode"/>
                            <span class="label-text">删除无音乐文件夹</span>
                        </label>
                    </div>
                    <div class="form-control w-72">
                        <label class="label cursor-pointer">
                            <input type="radio" name="radio-10" class="radio checked:bg-red-500 radio-error" value="all"
                                   v-model="deleteMode"/>
                            <span class="label-text">删除勾选所有文件夹和文件（慎用）</span>
                        </label>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="removeNullFolderFunc">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import SingleSelect from "@/components/iview/SingleSelect";
import MultiSelect from "@/components/iview/MultiSelect";

export default {
    name: 'batch-action',
    components: {SingleSelect, MultiSelect},
    data() {
        return {
            settingCheckBox: false,
            handModifyCheckBox: false,
            autoModifyCheckBox: false,
            tidyFolderCheckBox: false,
            splitFilenameCheckBox: false,
            isLoading: false,
            isShowDupCheck: false,
            batchSettingFormData: {
                'isOpenDetail': localStorage.getItem('isOpenDetail') !== 'false',
                'isDepth': localStorage.getItem('isDepth') === 'true',
                'limit': localStorage.getItem('limit') ? localStorage.getItem('limit') : 100
            },
            showFields: localStorage.getItem('showFields') ? JSON.parse(localStorage.getItem('showFields')) : ['filename', 'artist', 'album', 'albumartist', 'genre', 'year', 'lyrics', 'lyrics_file', 'comment', 'album_img', 'size', 'album_type', 'description', 'discnumber', 'tracknumber', 'totaltracks', 'totaldiscs', 'bit_rate', 'sample_rate', 'channels', 'bit_depth', 'language', 'duration'],
            showFieldsID3: localStorage.getItem('showFieldsID3') ? JSON.parse(localStorage.getItem('showFieldsID3')) : ['album_img', 'filename', 'title', 'artist', 'album', 'albumartist', 'lyrics', 'lyrics_file', 'year', 'genre'],
            fieldListID3: [
                {id: 'title', name: '标题'},
                {id: 'filename', name: '文件名'},
                {id: 'artist', name: '艺术家'},
                {id: 'album', name: '专辑'},
                {id: 'album_type', name: '专辑类型'},
                {id: 'albumartist', name: '专辑艺术家'},
                {id: 'discnumber', name: '光盘编号'},
                {id: 'tracknumber', name: '音轨号'},
                {id: 'totaltracks', name: '总音轨数'},
                {id: 'totaldiscs', name: '总光盘数'},
                {id: 'genre', name: '风格'},
                {id: 'year', name: '年份'},
                {id: 'lyrics', name: '歌词'},
                {id: 'lyrics_file', name: '歌词(LRC文件)'},
                {id: 'comment', name: '描述'},
                {id: 'description', name: '描述2'},
                {id: 'album_img', name: '专辑封面'},
                {id: 'duration', name: '时长'},
                {id: 'size', name: '文件大小'},
                {id: 'bit_rate', name: '比特率'},
                {id: 'sample_rate', name: '采样率'},
                {id: 'channels', name: '声道'},
                {id: 'bit_depth', name: '位深度'},
                {id: 'language', name: '语言'},
                {id: 'composer', name: '作曲家'},
                {id: 'lyricist', name: '作词家'}
            ],
            replaceOptions: [
                {id: 'text', name: '全文替换'},
                {id: 'regex', name: '正则替换'}
            ],
            // ruleList: ['${tracknumber}\\.${title}', '${tracknumber} ${title}', '${title}-${artist}-${album}'],
            ruleList: ['(?P<tracknumber>\\d+)\\.(?P<title>\\w+)', '(?P<tracknumber>\\w+) (?P<title>\\w+)', '(?P<title>\\w+)-(?P<artist>\\w+)-(?P<album>\\w+)'],
            ruleListTitle: ['(?P<tracknumber>\\d+)\\.(?P<title>\\w+)', '(?P<tracknumber>\\w+) (?P<title>\\w+)', '(?P<title>\\w+)-(?P<artist>\\w+)-(?P<album>\\w+)'],
            ruleListLyrics: ['作曲.*[:：]{1}(?P<composer>.*)\n', '作词.*[:：]{1}(?P<lyricist>.*)\n',
                '曲.*[:：]{1}(?P<composer>.*)\n', '词.*[:：]{1}(?P<lyricist>.*)\n',
                'Composed by.*[:：]{1}(?P<composer>.*)\n', 'Lyrics by.*[:：]{1}(?P<lyricist>.*)\n'
            ],
            extractField: 'filename',
            extractList: [
                {id: 'filename', name: '文件名'},
                {id: 'title', name: '标题'},
                {id: 'lyrics', name: '歌词'}
            ],
            modifyListL: ['title', 'artist', 'album'],
            exampleSetting2: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting3: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting4: {
                primary: {
                    visible: false,
                    headerPosition: 'left',
                    type: ''
                }
            },
            exampleSetting5: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting6: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting7: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting8: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting9: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting11: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting12: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            modifyListLanguage: [
                {id: 'title', name: '标题'},
                {id: 'artist', name: '艺术家'},
                {id: 'album', name: '专辑'},
                {id: 'albumartist', name: '专辑艺术家'},
                {id: 'lyrics', name: '歌词'},
                {id: 'comment', name: '描述'},
                {id: 'filename', name: '文件名称'},
                {id: 'genre', name: '风格'},
                {id: 'composer', name: '作曲家'},
                {id: 'lyricist', name: '作词家'},
            ],
            replaceMode: 'text',
            replaceTextList: [
                {'before': '', 'after': ''},
                {'before': '', 'after': ''},
                {'before': '', 'after': ''}
            ],
            selectFormat: 'mp3',
            formatList: [
                {id: 'mp3', name: 'MP3'},
                {id: 'wav', name: 'WAV'},
                {id: 'flac', name: 'FLAC'},
                {id: 'wma', name: 'WMA'},
                {id: 'ogg', name: 'OGG'}
            ],
            selectBitRate: '-1',
            selectBitRateCustom: '',
            bitRateList: [
                {id: '-1', name: '保持原样'},
                {id: '32', name: '32k'},
                {id: '64', name: '64k'},
                {id: '96', name: '96k'},
                {id: '128', name: '128k'},
                {id: '160', name: '160k'},
                {id: '192', name: '192k'},
                {id: '224', name: '224k'},
                {id: '256', name: '256k'},
                {id: '320', name: '320k'},
                {id: 'custom', name: '自定义'}
            ],
            selectSampleRate: '-1',
            selectSampleRateCustom: '',
            sampleRateList: [
                {id: '-1', name: '保持原样'},
                {id: '11025', name: '11025'},
                {id: '22050', name: '22050'},
                {id: '44100', name: '44100'},
                {id: '48000', name: '48000'},
                {id: 'custom', name: '自定义'}
            ],
            isKeepSource: true,
            musicInfoManual: {},
            albumTypeList: [
                {id: 'album;album', name: '普通(album;album)'},
                {id: 'ep', name: 'EP(ep)'},
                {id: 'album;compilation', name: '合集(album;compilation)'},
                {id: 'album;live', name: '现场(album;live)'},
                {id: 'album;remix', name: '混音(album;remix)'},
                {id: 'album;soundtrack', name: '原声(album;soundtrack)'},
                {id: 'album;demo', name: '演示(album;demo)'},
                {id: 'single', name: '单曲(single)'}
            ],
            isSaveLyricsFile: false,
            isSaveAlbumCover: false,
            isImportAlbumCover: false,
            isImportLyricsFile: false,
            reloadImg: true,
            uploadUrl: '/api/upload_image/',
            uploadHeader: [
                {name: 'X-CSRFToken', value: this.getCookie('django_vue_cli_csrftoken')},
                {name: 'AUTHORIZATION', value: this.getCookie('AUTHORIZATION')}
            ],
            files1: [],
            genreInputList: [],
            languageInputList: [],
            albumArtistInputList: [],
            genreList: [
                {'id': '流行', name: '流行'},
                {'id': '摇滚', name: '摇滚'},
                {'id': '说唱', name: '说唱'},
                {'id': '民谣', name: '民谣'},
                {'id': '电子', name: '电子'},
                {'id': '爵士', name: '爵士'},
                {'id': '纯音乐', name: '纯音乐'},
                {'id': '金属', name: '金属'},
                {'id': '世界音乐', name: '世界音乐'},
                {'id': '新世纪', name: '新世纪'},
                {'id': '古典', name: '古典'},
                {'id': '独立', name: '独立'},
                {'id': '氛围音乐', name: '氛围音乐'}
            ],
            languageList: [
                {'id': '中文', name: '中文'},
                {'id': '英文', name: '英文'},
                {'id': '日文', name: '日文'},
                {'id': '韩文', name: '韩文'},
                {'id': '泰文', name: '泰文'},
                {'id': '未知', name: '未知'}
            ],
            tidyList: [
                {id: 'title', name: '标题'},
                {id: 'artist', name: '艺术家'},
                {id: 'album', name: '专辑'},
                {id: 'album_artist', name: '专辑艺术家'},
                {id: 'album_type', name: '专辑类型'},
                {id: 'genre', name: '风格'},
                {id: 'language', name: '语言'},
                {id: 'track_number', name: '音轨号'},
                {id: 'disc_number', name: '光盘编号'},
                {id: 'comment', name: '描述'},
                {id: 'custom', name: '自定义'}
            ],
            albumArtistList: [],
            tidyFormData: {
                root_path: localStorage.getItem('tidy_root_path') || '/app/media/',
                dir_list: [{'value': 'artist'}, {'value': 'album'}]
            },
            isSkipTag: true,
            isSkipExist: true,
            isFolderAlbum: false,
            modifyList: ['artist', 'album', 'album_img', 'year', 'lyrics'],
            resourceListBatch: [
                {id: 'netease', name: '网易云音乐'},
                {id: 'migu', name: '咪咕音乐'},
                {id: 'qmusic', name: 'QQ音乐'},
                {id: 'kugou', name: '酷狗音乐'},
                {id: 'kuwo', name: '酷我音乐'}
            ],
            modifyListBatch: [
                {id: 'title', name: '标题'},
                {id: 'artist', name: '艺术家'},
                {id: 'album', name: '专辑'},
                {id: 'albumartist', name: '专辑艺术家'},
                {id: 'album_img', name: '专辑封面'},
                {id: 'year', name: '年份'},
                {id: 'lyrics', name: '歌词'},
                {id: 'is_save_lyrics_file', name: '歌词(LRC文件)'},
                {id: 'discnumber', name: '光盘编号'},
                {id: 'tracknumber', name: '音轨号'},
                {id: 'composer', name: '作曲家'},
                {id: 'lyricist', name: '作词家'}
            ],
            selectAutoMode: 'simple',
            sourceList: ['netease', 'qmusic'],
            forceDeleteWithoutMusic: false,
            forceDeleteAll: false,
            deleteMode: 'null'
        }
    },
    computed: {
        ...mapGetters(['geFullPath', 'getUserRole']),
        filePath: {
            get() {
                const fullPath = this.geFullPath
                return fullPath
            }
        },
        checkedIds: {
            get() {
                return this.$store.state.common.checkedIds
            },
            set(value) {
                this.$store.commit('setCheckedIds', value)
            }
        },
        checkedData: {
            get() {
                return this.$store.state.common.checkedData
            },
            set(value) {
                this.$store.commit('setCheckedData', value)
            }
        }
    },
    methods: {
        handleBatchSettings() {
            window.localStorage.setItem('isOpenDetail', this.batchSettingFormData.isOpenDetail)
            window.localStorage.setItem('isDepth', this.batchSettingFormData.isDepth)
            window.localStorage.setItem('limit', this.batchSettingFormData.limit)
            const obj = JSON.stringify(this.showFieldsID3)
            window.localStorage.setItem('showFieldsID3', obj)
            this.settingCheckBox = false
            this.$myMsg.notify({
                title: '保存成功！',
                content: "设置已保存，请刷新页面生效",
                type: 'success',
                time: 2000,
            });
        },
        handleChangeLanguage(type) {
            this.exampleSetting4.primary.type = type
            this.$refs.trans_font.showModal()
        },
        removeNullFolderFunc() {
            this.$bkInfo({
                title: '确认要删除文件夹？',
                confirmLoading: true,
                confirmFn: () => {
                    try {
                        this.isLoading = true
                        this.$api.Task.removeNullFolder(
                            {
                                'file_full_path': this.filePath,
                                'select_data': this.checkedData,
                                'delete_mode': this.deleteMode
                            }).then((res) => {
                            this.isLoading = false
                            if (res.result) {
                                this.$myMsg.notify({
                                    title: '创建成功！',
                                    content: "任务在后台努力运行中",
                                    type: 'success',
                                    time: 2000,
                                })
                                this.$parent.handleSearchFile()
                            } else {
                                this.$myMsg.notify({
                                    title: '创建失败！',
                                    content: res.message.data.message ? res.message.data.message : '创建失败',
                                    type: 'error',
                                    time: 5000,
                                })
                            }
                        })
                        return true
                    } catch (e) {
                        console.warn(e)
                        return false
                    }
                }
            })
        },
        splitFilenameFunc() {
            this.$bkInfo({
                title: '确认要拆分元数据？',
                confirmLoading: true,
                confirmFn: () => {
                    try {
                        this.isLoading = true
                        this.$api.Task.splitFilename(
                            {
                                'file_full_path': this.filePath,
                                'select_data': this.checkedData,
                                'rule_list': this.ruleList,
                                'extract_field': this.extractField
                            }).then((res) => {
                            this.isLoading = false
                            if (res.result) {
                                this.$myMsg.notify({
                                    title: '创建成功！',
                                    content: "任务在后台努力运行中",
                                    type: 'success',
                                    time: 2000,
                                })
                                this.$parent.handleSearchFile()
                            } else {
                                this.$myMsg.notify({
                                    title: '创建失败！',
                                    content: res.message.data.message ? res.message.data.message : '创建失败',
                                    type: 'error',
                                    time: 5000,
                                })
                            }
                        })
                        return true
                    } catch (e) {
                        console.warn(e)
                        return false
                    }
                }
            })
        },
        replaceTextFunc() {
            this.$bkInfo({
                title: '确认要替换文本？',
                confirmLoading: true,
                confirmFn: () => {
                    try {
                        this.isLoading = true
                        this.$api.Task.replaceText(
                            {
                                'file_full_path': this.filePath,
                                'select_data': this.checkedData,
                                'replace_text_list': this.replaceTextList,
                                'modify_list': this.modifyListL,
                                'replace_mode': this.replaceMode
                            }).then((res) => {
                            this.isLoading = false
                            if (res.result) {
                                this.$myMsg.notify({
                                    title: '创建成功！',
                                    content: "任务在后台努力运行中",
                                    type: 'success',
                                    time: 2000,
                                })
                                this.$parent.handleSearchFile()
                            } else {
                                this.$myMsg.notify({
                                    title: '创建失败！',
                                    content: res.message.data.message ? res.message.data.message : '创建失败',
                                    type: 'error',
                                    time: 5000,
                                })
                            }
                        })
                        return true
                    } catch (e) {
                        console.warn(e)
                        return false
                    }
                }
            })
        },
        fixEncodingFunc() {
            try {
                this.isLoading = true
                this.$api.Task.fixEncoding(
                    {
                        'file_full_path': this.filePath,
                        'select_data': this.checkedData,
                        'replace_text_list': this.replaceTextList,
                        'modify_list': this.modifyListL
                    }).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.$myMsg.notify({
                            title: '创建成功！',
                            content: "任务在后台努力运行中",
                            type: 'success',
                            time: 2000,
                        })
                        this.$parent.handleSearchFile()
                    } else {
                        this.$myMsg.notify({
                            title: '创建失败！',
                            content: res.message.data.message ? res.message.data.message : '创建失败',
                            type: 'error',
                            time: 5000,
                        })
                    }
                })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        checkForDuplicates() {
            try {
                this.isLoading = true
                this.$api.Task.checkDuplicate(
                    {
                        'file_full_path': this.filePath,
                        'select_data': this.checkedData,
                    }).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.$myMsg.notify({
                            title: '创建成功！',
                            content: "任务在后台努力运行中",
                            type: 'success',
                            time: 2000,
                        })
                        this.isShowDupCheck = false

                    } else {
                        this.$myMsg.notify({
                            title: '创建失败！',
                            content: res.message.data.message ? res.message.data.message : '创建失败',
                            type: 'error',
                            time: 5000,
                        })
                    }
                })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        formatMusicFunc() {
            this.$bkInfo({
                title: '确认要格式文件？',
                confirmLoading: true,
                confirmFn: () => {
                    try {
                        this.isLoading = true
                        this.$api.Task.formatMusic(
                            {
                                'file_full_path': this.filePath,
                                'select_data': this.checkedData,
                                'music_type': this.selectFormat,
                                'bit_rate': this.selectBitRate,
                                'bit_rate_custom': this.selectBitRateCustom,
                                'sample_rate': this.selectSampleRate,
                                'sample_rate_custom': this.selectSampleRateCustom,
                                'is_keep_source': this.isKeepSource
                            }).then((res) => {
                            this.isLoading = false
                            if (res.result) {
                                this.$myMsg.notify({
                                    title: '创建成功！',
                                    content: "任务在后台努力运行中",
                                    type: 'success',
                                    time: 2000,
                                })
                                this.$parent.handleSearchFile()
                            } else {
                                this.$myMsg.notify({
                                    title: '创建失败！',
                                    content: res.message.data.message ? res.message.data.message : '创建失败',
                                    type: 'error',
                                    time: 5000,
                                })
                            }
                        })
                        return true
                    } catch (e) {
                        console.warn(e)
                        return false
                    }
                }
            })
        },
        splitCueFunc() {
            this.$bkInfo({
                title: '确认要切分 CUE？',
                confirmLoading: true,
                confirmFn: () => {
                    try {
                        this.isLoading = true
                        this.$api.Task.splitCueMusic(
                            {
                                'file_full_path': this.filePath,
                                'select_data': this.checkedData
                            }).then((res) => {
                            this.isLoading = false
                            if (res.result) {
                                this.$myMsg.notify({
                                    title: '创建成功！',
                                    content: "任务在后台努力运行中",
                                    type: 'success',
                                    time: 2000,
                                })
                                this.$parent.handleSearchFile()
                            } else {
                                this.$myMsg.notify({
                                    title: '创建失败！',
                                    content: res.message.data.message ? res.message.data.message : '创建失败',
                                    type: 'error',
                                    time: 5000,
                                })
                            }
                        })
                        return true
                    } catch (e) {
                        console.warn(e)
                        return false
                    }
                }
            })
        },
        importMusic() {
            this.isLoading = true

            this.$api.Task.importMusicIn({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_info': {},
                'is_skip_exist': this.isSkipExist
            }).then((res) => {
                this.isLoading = false
                console.log(res)
                if (res.result) {
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        handleBatch() {
            try {
                this.isLoading = true

                this.musicInfoManual.genre = this.genreInputList[0]
                this.musicInfoManual.language = this.languageInputList[0]
                this.musicInfoManual.albumartist = this.albumArtistInputList[0]
                this.musicInfoManual.is_save_lyrics_file = this.isSaveLyricsFile
                this.musicInfoManual.is_import_lyrics_file = this.isImportLyricsFile
                this.musicInfoManual.is_save_album_cover = this.isSaveAlbumCover
                this.musicInfoManual.is_import_album_cover = this.isImportAlbumCover

                this.$api.Task.batchUpdateId3({
                    'file_full_path': this.filePath,
                    'select_data': this.checkedData,
                    'music_info': this.musicInfoManual
                }).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.handModifyCheckBox = false
                        this.$myMsg.notify({
                            title: '创建成功！',
                            content: "任务在后台努力运行中",
                            type: 'success',
                            time: 2000,
                            url: '/#/log'
                        });
                    }
                })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        handleResBatch(response) {
            if (response.result) {
                this.musicInfoManual.album_img = response.data
                return true
            } else {
                return false
            }
        },
        // 批量自动修改
        handleBatchAuto() {
            try {
                this.isLoading = true
                this.musicInfoManual['select_mode'] = this.selectAutoMode
                this.musicInfoManual['source_list'] = this.sourceList
                this.musicInfoManual['is_skip_tag'] = this.isSkipTag
                this.musicInfoManual['is_folder_album'] = this.isFolderAlbum
                this.$api.Task.batchAutoUpdateId3({
                    'file_full_path': this.filePath,
                    'select_data': this.checkedData,
                    'music_info': this.musicInfoManual,
                    'modify_list': this.modifyList
                }).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.autoModifyCheckBox = false
                        this.$myMsg.notify({
                            title: '创建成功！',
                            content: "任务在后台努力运行中",
                            type: 'success',
                            time: 2000,
                            url: '/#/log'
                        });
                    }
                })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        // 整理文件夹
        handleTidy() {
            this.$bkInfo({
                title: '确认要整理文件夹？',
                confirmLoading: true,
                confirmFn: () => {
                    try {
                        this.isLoading = true
                        this.tidyFormData['file_full_path'] = this.filePath
                        this.tidyFormData['select_data'] = this.checkedData
                        this.$api.Task.tidyFolder(this.tidyFormData).then((res) => {
                            this.isLoading = false
                            if (res.result) {
                                this.$myMsg.notify({
                                    title: '创建成功！',
                                    content: "任务在后台努力运行中",
                                    type: 'success',
                                    time: 2000,
                                })
                                window.localStorage.setItem('tidy_root_path', this.tidyFormData.root_path)
                                this.$parent.handleSearchFile()
                            } else {
                                this.$myMsg.notify({
                                    title: '创建失败！',
                                    content: res.message.data.message ? res.message.data.message : '创建失败',
                                    type: 'error',
                                    time: 5000,
                                })
                            }
                        })
                        return true
                    } catch (e) {
                        console.warn(e)
                        return false
                    }
                }
            })
        },
        handleChangeLanguageFunc() {
            this.isLoading = true
            this.$api.Task.simplifiedFields({
                'mode': this.exampleSetting4.primary.type,
                'modify_list': this.modifyListL,
                'file_full_path': this.filePath,
                'select_data': this.checkedData
            }).then((res) => {
                this.isLoading = false
                if (res.result) {
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        addInput() {
            this.tidyFormData.dir_list.push({value: ''}) // 添加新的输入框
        },
        removeInput(index) {
            this.tidyFormData.dir_list.splice(index, 1) // 删除指定索引的输入框
        },
        handleHide() {
            this.musicInfoManual.album_img = ''
        },
        handleExtractChange() {
            if (this.extractField === 'filename') {
                this.ruleList = this.ruleListTitle
            } else if (this.extractField === 'title') {
                this.ruleList = this.ruleListTitle
            } else if (this.extractField === 'lyrics') {
                this.ruleList = this.ruleListLyrics
            }
        }
    }
}
</script>

<style scoped>

</style>
